import React from "react";
import { Divider, Grid, Stack, Typography } from "@mui/material";
import { BtnExportExcel } from "components/Button/ButtonAll";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import moment from "moment";
import { FormProvider, useForm } from "react-hook-form";
import { FnAxios, FnDialog, I18n } from "utilities/utilities";
moment.locale('th');

const ReportIncomeExpense = () => {
  const DialogFn = FnDialog();
  const AxiosFn = FnAxios();
  const formSummary = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });
  const formRawData = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });

  const formExpenses = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });

  const formFundAcc = useForm({
    shouldFocusError: true,
    mode: "all",
    defaultValues: {} as any,
  });

  const handdleExportSummaryReport = () => {
    DialogFn.BlockUI();
    const ObjForm = formSummary.getValues();
    const nSetYear = ObjForm.dYearPickerSummaryReport ? moment(ObjForm.dYearPickerSummaryReport).valueOf() : null;
    let param = {
      nYear: nSetYear,
    }

    let nThaiYear = moment(ObjForm.dYearPickerSummaryReport).format("yyyy");
    let sFileName = `สรุปรายได้จากการดำเนินงาน ประจำปี ${+nThaiYear + 543}.xlsx`

    AxiosFn.DowloadFileBlob(`ReportIncomeExpense/onExportSummaryReport`, param, sFileName, (result) => {
      DialogFn.UnBlockUI();
    });
  }

  const handdleExportRawDataReport = () => {
    DialogFn.BlockUI();
    const ObjForm = formRawData.getValues();
    const nSetYear = ObjForm.dYearPickerRawDataReport ? moment(ObjForm.dYearPickerRawDataReport).valueOf() : null;
    let param = {
      nYear: nSetYear
    }

    let nThaiYear = moment(ObjForm.dYearPickerRawDataReport).format("yyyy");
    let sFileName = `ข้อมูลรายรับ-รายจ่าย (Raw data) ประจำปี ${+nThaiYear + 543}.xlsx`
    AxiosFn.DowloadFileBlob(`ReportIncomeExpense/onExportRawDataReport`, param, sFileName, (result) => {
      DialogFn.UnBlockUI();
    });
  }


  const haddleExportExpensesReport = () => {
    DialogFn.BlockUI();
    const ObjForm = formExpenses.getValues();
    const nSetYear = ObjForm.dYearPickerExpenses ? moment(ObjForm.dYearPickerExpenses).valueOf() : null;
    let param = {
      nYear: nSetYear
    }
    let nThaiYear = moment(ObjForm.dYearPickerExpenses).format("yyyy");
    let sFileName = `สรุปรายจ่ายการดำเนินงาน ประจำปี ${+nThaiYear + 543}.xlsx`
    AxiosFn.DowloadFileBlob(`ReportIncomeExpense/onExportExpensesReport`, param, sFileName, (result) => {
      DialogFn.UnBlockUI();
    }, (err) => {
      DialogFn.Warning(err.sMessage)
      DialogFn.UnBlockUI()
    });
  }

  const handdleExportFundAccounting = () => {
    DialogFn.BlockUI();
    const dataForm = formFundAcc.getValues();
    let param = {
      dDate: moment(dataForm.dDate).valueOf()
    }

    let nThaiYear = moment(dataForm.dDate).format("yyyy");
    let sMonth = moment(dataForm.dDate).format("MMMM");
    let sFileName = `รายงานการรับ-จ่ายเงิน ประจำเดือน-ปี ${sMonth} ${+nThaiYear + 543}.xlsx`
    AxiosFn.DowloadFileBlob(`FundAccounting/ExportReportFundAccounting`, param, sFileName, (result) => {
      DialogFn.UnBlockUI();
    }, (err) => {
      DialogFn.Warning(err.sMessage)
      DialogFn.UnBlockUI()
    });
  }

  return (
    <React.Fragment>

      <FormProvider {...formSummary}>
        <Typography style={{ fontSize: 18, fontWeight: 600, color: "#0056b3" }}>
          รายงานรายรับ-รายจ่าย
        </Typography>
        <Divider textAlign="left" sx={{ fontSize: 18 }}>สรุปรายได้จากการดำเนินงาน</Divider>
        <Stack direction={"row"} spacing={2} sx={{ my: "2%", mx: "4%" }}>
          <Grid>
            <DatePickerItem
              name={`dYearPickerSummaryReport`}
              id={`dYearPickerSummaryReport`}
              label={I18n.SetText("exampleComponents.yearPicker")}
              IsYearPicker
              // maxDate={moment()}
              required={true}
              disabled={false}
            // onChange={(e) => { if (e !== null) { handleCheckYearAvilable(e) } }}
            />
          </Grid>
          <Grid>
            <BtnExportExcel id={"expSummaryReport"} onClick={formSummary.handleSubmit((e) => { handdleExportSummaryReport() })} />
          </Grid>
        </Stack>
      </FormProvider>

      <FormProvider {...formRawData}>
        <Divider textAlign="left" sx={{ mt: "4%", fontSize: 18 }} >ข้อมูลรายรับ-รายจ่าย (Raw Data)</Divider>
        <Stack direction={"row"} spacing={2} sx={{ mt: "2%", mb: "4%", mx: "4%" }}>
          <Grid>
            <DatePickerItem
              name={`dYearPickerRawDataReport`}
              id={`dYearPickerRawDataReport`}
              label={I18n.SetText("exampleComponents.yearPicker")}
              IsYearPicker
              // maxDate={moment()}
              required={true}
              disabled={false}
            />
          </Grid>
          <Grid>
            <BtnExportExcel id={"expIncomeExpense"} onClick={formRawData.handleSubmit((e) => { handdleExportRawDataReport() })} />
          </Grid>
        </Stack>
      </FormProvider>

      <FormProvider {...formFundAcc}>
        <Divider textAlign="left" sx={{ mt: "4%", fontSize: 18 }} >รายงานการรับ-จ่ายเงิน</Divider>
        <Stack direction={"row"} spacing={2} sx={{ mt: "2%", mb: "4%", mx: "4%" }}>
          <Grid>
            <DatePickerItem
              id={`dDate`}
              name={`dDate`}
              label={`ประจำเดือน-ปี`}
              required
              fullWidth
              IsMonthYearPicker
              format="MMMM YYYY"
            />
          </Grid>
          <Grid>
            <BtnExportExcel id={"expIncomeExpense"} onClick={formFundAcc.handleSubmit((e) => { handdleExportFundAccounting() })} />
          </Grid>
        </Stack>
      </FormProvider>

      <FormProvider {...formExpenses}>
        <Divider textAlign="left" sx={{ mt: "4%", fontSize: 18 }} >สรุปรายจ่ายจากการดำเนินงาน</Divider>
        <Stack direction={"row"} spacing={2} sx={{ mt: "2%", mb: "4%", mx: "4%" }}>
          <Grid>
            <DatePickerItem
              name={"dYearPickerExpenses"}
              id={`dYearPickerExpenses`}
              label={I18n.SetText("exampleComponents.yearPicker")}
              IsYearPicker
              required={true}
              disabled={false}
            />
          </Grid>
          <Grid>
            <BtnExportExcel id={"expExpenses"} onClick={formExpenses.handleSubmit((e) => { haddleExportExpensesReport() })} />
          </Grid>
        </Stack>
      </FormProvider>
    </React.Fragment>
  );
}

export default ReportIncomeExpense